import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box, Button, Container, Typography } from '@mui/material';
import LogoOnlyLayout from '../../layouts/LogoOnlyLayout';
import { PATH_AUTH } from '../../routes/paths';
import Page from '../../components/Page';
import { useTranslation } from 'react-i18next';
import SetPasswordform from './SetPasswordform';

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

export default function SetPassword() {
  const { t } = useTranslation();
  const [status, setStatus] = useState(false);

  return (
    <Page title={t('set_password')} sx={{ height: 1 }}>
      <RootStyle>
        <LogoOnlyLayout />
        <Container>
          <Box sx={{ maxWidth: 480, mx: 'auto' }}>
            {!status ? (
              <>
                <Typography variant='h3' paragraph>
                  {t('set_password')}
                </Typography>

                <Typography sx={{ color: 'text.secondary', mb: 5 }}>
                  {t('your_password_conatain_characters')}
                </Typography>

                <SetPasswordform onStatus={() => setStatus(true)} />
              </>
            ) : (
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant='h3' gutterBottom>
                  {t('password_change_successfully')}
                </Typography>

                <Button
                  size='large'
                  variant='contained'
                  component={RouterLink}
                  to={PATH_AUTH.login}
                  sx={{ mt: 5 }}
                >
                  {t('back')}
                </Button>
              </Box>
            )}
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
}
